import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://zapido.ai";

function setCanonical(url: string) {
  let canonicalTag = document.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!canonicalTag) {
    canonicalTag = document.createElement("link");
    canonicalTag.rel = "canonical";
    document.head.appendChild(canonicalTag);
  }

  canonicalTag.href = url;
}

function toCanonicalPath(pathname: string): string {
  if (pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

export default function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalPath = toCanonicalPath(pathname);
    setCanonical(`${BASE_URL}${canonicalPath}`);
  }, [pathname]);

  return null;
}
